export default __webpack_public_path__ + "static/media/bed12.dda0ff58.png";